export default __webpack_public_path__ + "static/media/PAYTM1.af57f47d.png";